import React from 'react';
import PropTypes from 'prop-types';
import SingleButton from '../SingleButton/SingleButton';
import T from '../../../../common/components/T';
import css from './FormButtons.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';

const FormButtons = ({ formName, buttons, sendFormData, customFormButton, buttonText, tabsData, requestLoading }) => {
    const { stylers, classes } = generateCompStylers(customFormButton);
    return (
        <div
            style={stylers.wrapper}
            className={classnames(
                css.formBottomButtonGroup,
                customFormButton?.isFullWidth ? css.formBottomButtonGroupLarge : '',
                classes.wrapper
            )}
        >
            <div style={stylers.flex} className={classnames(css.formGroupButtonItemWrap, classes.flex)}>
                {!(buttons && Array.isArray(buttons) && buttons.length) ? (
                    <SingleButton
                        formName={formName}
                        key={`${formName}buttonOk`}
                        type='ok'
                        clickFunc={sendFormData}
                        buttonText={buttonText || <T textName='send' defaultStr='Отправить' page='all' />}
                        customButton={customFormButton?.ok}
                        requestLoading={requestLoading}
                    />
                ) : (
                    buttons.map((item, idx) => (
                        <SingleButton
                            key={`${formName}button${idx}`}
                            formName={formName}
                            type={item.type}
                            clickFunc={
                                item.type === 'ok'
                                    ? sendFormData
                                    : tabsData && item.type === 'next'
                                    ? () => {
                                          if (tabsData.nextAlias !== 'end') {
                                              tabsData.setActiveTab(tabsData.nextAlias);
                                              tabsData.setCountNextTab(tabsData.countNextTab + 1);
                                          }
                                      }
                                    : item.clickFunc
                            }
                            requestLoading={requestLoading}
                            buttonText={
                                item.buttonText ? (
                                    item.buttonText
                                ) : item.type === 'ok' ? (
                                    <T textName='send' defaultStr='Отправить' page='all' />
                                ) : (
                                    <T textName='cancel' defaultStr='Отмена' page='all' />
                                )
                            }
                            customButton={customFormButton ? customFormButton[item.type] : false}
                            icon={item?.icon}
                            arrow={item?.arrow}
                            hiddenButtonText={item?.hiddenButtonText}
                            disabled={item?.disabled}
                        />
                    ))
                )}
            </div>
        </div>
    );
};
FormButtons.propTypes = {
    formName: PropTypes.string,
    buttons: PropTypes.array,
    sendFormData: PropTypes.func,
    customFormButton: PropTypes.object,
    buttonText: PropTypes.node,
    tabsData: PropTypes.object
};
export default FormButtons;
